<template>
	<div>
		<div class="op sc hand" style="margin: 20px;color: #1C7EFF" @click="a('/test/cropperExample')">裁剪组件</div>
		<div class="op sc hand" style="margin: 20px;color: #1C7EFF" @click="a('/test/calendarExample')">日历组件</div>
		<div class="op sc hand" style="margin: 20px;color: #1C7EFF" @click="a('/test/videoCallExample')">视频通话组件</div>
		<div class="op sc hand" style="margin: 20px;color: #1C7EFF" @click="a('/test/liveExample')">直播组件</div>
		<div class="op sc hand" style="margin: 20px;color: #1C7EFF" @click="a('/test/GuideExample')">导游组件</div>
	</div>

</template>

<script>
export default {
	name: "index"
}
</script>

<style scoped>

</style>